import { startOfWeek } from 'date-fns';
import { isAdmin, isProjectQaReportPlannedVsActual } from '../../../utils/share';

export const INITIAL_DATE_RANGE_VALUE = {
  selection: {
    startDate: startOfWeek(new Date(), { weekStartsOn: 1 }),
    endDate: new Date(),
    key: 'selection',
  },
};

export const BILLABLE_OPTION = [
  { id: 1, name: 'Billable', value: 'Yes', label: 'Billable' },
  { id: 2, name: 'Non-billable', value: 'No', label: 'Non-billable' },
];

export const INITIAL_FILTER_VALUES = {
  dateRange: INITIAL_DATE_RANGE_VALUE,
  clientList: [],
  projectList: [],
  projectStatusList: [],
  taskStatusList: [],
  employeeList: [],
  graphList: [],
  taskNote: '',
  taskTypeList: [],
  billableTypeList: [],
};

export const INITIAL_REPORT_FILTER_STATE = {
  dateRange: INITIAL_DATE_RANGE_VALUE,
  selectedClientIds: [],
  selectedProjectIds: [],
  selectedProjectStatusList: [],
  selectedTaskStatusList: [],
  selectedEmployeeIds: [],
  selectedGraphList: [],
  taskNote: '',
  taskTypeList: [],
  selectedBillableIds: [],
};

export const INITIAL_REPORT_STATE = {
  dayWiseHourReport: null,
  clientReport: { graph: null, table: [] },
  projectReport: { graph: null, table: [] },
  employeeReport: { graph: null, table: [] },
  taskNoteReport: { graph: null, table: [] },
  timeSheetReport: { table: [] },
  plannedVsActualReport: { table: [] },
};

export const GRAPH_LIST = [
  'Time Line Report',
  'Client Report',
  'Project Report',
  isAdmin() && 'Employee Report',
  'Task Note Report',
  'Timesheet Report',
  'Task Type Report',
  (isAdmin() || isProjectQaReportPlannedVsActual()) && 'Planned vs Actual Report',
].filter(Boolean);
